import { defineStore } from "pinia";
import type { Sprache } from "@/models/Sprache";
import type { LangLocales } from "@/models/LangLocales";
import LanguageService from "@/services/LanguageService";

interface LanguageState {
  defaultLanguage: Sprache;
  currentLangId: string;
  availableLanguages: Sprache[] | null;
  langIdToLocale: Record<string, LangLocales>;
  localeToFullLanguage: Record<LangLocales, string>;
}

export const useLanguageStore = defineStore("language", {
  state: (): LanguageState => ({
    defaultLanguage: {
      id: "1751CDBCE1E",
      bezeichnung: "Deutsch",
      kuerzel: "de",
    },
    currentLangId: localStorage.getItem("currentLangId") || "1751CDBCE1E", // initially default language id
    availableLanguages: null, // Will be populated from auswahlwerte.sprachen
    langIdToLocale: {
      "1751CDBCE1E": "de",
      "186559F7DBF": "fr",
      "180BC941F1F": "en",
      "187B79C94AC": "it",
    },
    localeToFullLanguage: {
      de: "Deutsch",
      fr: "Français",
      en: "English",
      it: "Italiano",
    },
  }),

  actions: {
    getLangIdByLocale(locale: LangLocales): string | null {
      return LanguageService.getLangIdByLocale(locale);
    },

    setLanguage(langId: string) {
      LanguageService.setLanguage(langId);
    },

    setAvailableLanguages(languages: Sprache[]) {
      LanguageService.setAvailableLanguages(languages);
    },

    async setLanguageTexts() {
      await LanguageService.setLanguageTexts();
    },
  },

  getters: {
    currentLanguage: (state): Sprache | null =>
      state.availableLanguages?.find(
        (lang) => lang.id === state.currentLangId
      ) || state.defaultLanguage,
  },
});
